import { toastEventDispatch } from '@hotmart/space-lib-events/dist/toast'
import { ToastType, ToastPosition } from '@hotmart/space-lib-events/dist/toast/enum'
import { useSchedulePostForm } from 'src/hook/useSchedulePostForm'

import i18n from 'src/i18n'

export const useCreatePostNotification = () => {
  const { formData } = useSchedulePostForm()

  const [[date, month], [hour, minutes]] = [
    formData.scheduledPubDate?.split('/'),
    formData.scheduledPubTime?.split(':')
  ];

  const payload = {
    success: {
      type: ToastType.SUCCESS,
      message: i18n.t('forms.schedule_posts.success_msg.publishing_post', {
        date: date && month ? `${date}/${month}` : '',
        time: hour && minutes ? `${hour}:${minutes}` : ''
      }),
      position: ToastPosition.BOTTOM_RIGHT
    },
    error: {
      type: ToastType.DANGER,
      message: i18n.t('forms.schedule_posts.error_msg.publishing_post'),
      position: ToastPosition.BOTTOM_RIGHT
    },
    date_error: {
      type: ToastType.DANGER,
      message: i18n.t('notifications.schedule.error_limit_days_times'),
      position: ToastPosition.BOTTOM_RIGHT
    }
  };

  return (type: keyof typeof payload) => toastEventDispatch(payload[type])
}